import type { StatEntry } from '../types'

export const TRADE_MIN_INTERVAL = 1000
export const CMD_CONFIG = {
  0: { color: '#0054F7', textKey: 'trading.order.type.buy' }, // 买入
  1: { color: '#ED0A34', textKey: 'trading.order.type.sell' }, // 卖出
  2: { color: '#0054F7', textKey: 'trading.order.type.buy-limit' }, // 买入限价
  3: { color: '#ED0A34', textKey: 'trading.order.type.sell-limit' }, // 卖出限价
  4: { color: '#0054F7', textKey: 'trading.order.type.buy-stop' }, // 买入止损
  5: { color: '#ED0A34', textKey: 'trading.order.type.sell-stop' }, // 卖出止损
  6: { color: '#0054F7', textKey: 'trading.order.type.hedged' }, // 对冲
}

export const EPSILON = 1e-9

export const SOCKET_CMD_TIMEOUT = 5000

export const QUOTE_UPDATE_INTERVAL = 500
export const CACHE_TTL = 30 * 60 * 1000 // 30 min
export const CHUNK_SIZE = 200 // 接口单次上限

export const initTotalStats = {
  totalFloatingPL: undefined as number | undefined,
  totalCommission: 0,
  totalSwaps: 0,
}

export const initCategoryStats: readonly StatEntry[] = [
  ['all', [0, 0, new Set<number>()]],
  ['buy', [1, 0, new Set<number>()]],
  ['sell', [2, 0, new Set<number>()]],
  ['profitable', [3, 0, new Set<number>()]],
  ['losing', [4, 0, new Set<number>()]],
]

export const POST_MESSAGE_INTERVAL = 500

export const MAX_SYMBOLS_TABS = 10
